import { useRef, useState, useCallback } from "react";
import { getSearchPayload, getSearchResultsWithPagination } from "services";
import { AUCTION_PAGE_SIZE } from "../constants/auction";
import { transformAuctionProperties } from "../utils/transformAuctionProperties";
import { useSelector } from "react-redux";

export const useAuctionPLSearch = ({
  router,
  searchForm,
}: {
  router: any;
  searchForm: any;
}) => {
  const requestIdRef = useRef(0);

  const shortListedProperties = useSelector((state: any) => {
    return state.auth?.user?.profile?.meta?.shortlisted_properties;
  });
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [noMore, setNoMore] = useState(false);

  const fetchPage = useCallback(
    async (pageToFetch: number, reset = false) => {
      const requestId = ++requestIdRef.current;
      setLoading(true);

      if (reset) {
        setData([]);
        setPage(1);
        setNoMore(false);
        searchForm.setField("total", 0);
      }

      try {
        const payload = getSearchPayload(searchForm, router, pageToFetch);
        const res: any = await getSearchResultsWithPagination(
          { searches: payload },
          AUCTION_PAGE_SIZE,
          pageToFetch,
        );

        if (requestId !== requestIdRef.current) return -1;

        const hits = res?.results?.[0]?.hits?.map((h: any) => h.document);
        const found = res?.results?.[0]?.found ?? 0;

        searchForm.setField("total", found);

        const transformed = transformAuctionProperties({
          properties: hits,
          shortListedProperties,
        });

        setData((prev) =>
          pageToFetch === 1 ? transformed : [...prev, ...transformed],
        );

        setPage(pageToFetch);

        if (!hits?.length || transformed?.length < AUCTION_PAGE_SIZE) {
          setNoMore(true);
        }
        setLoading(false);
        return found;
      } catch (err) {
        console.error("Error fetching auction properties:", err);
        setLoading(false);
        return -1;
      }
    },
    [router, searchForm, shortListedProperties],
  );

  return {
    data,
    loading,
    noMore,
    page,
    fetchFirstPage: () => fetchPage(1, true),
    fetchNextPage: () => fetchPage(page + 1),
  };
};
